const getDragValue = (e, format) => {
  try {
    if (!e || !e.dataTransfer || !e.dataTransfer.types) return null;
    for (let i = 0; i < e.dataTransfer.types.length; i += 1) {
      if (e.dataTransfer.types[i].toLowerCase() === format.toLowerCase())
        return e.dataTransfer.getData(e.dataTransfer.types[i]);
    }
    return null;
  } catch (ex) {
    return null;
  }
};
const containsDragFormat = (e, format) => {
  if (!e || !e.dataTransfer || !e.dataTransfer.types) return false;
  for (let i = 0; i < e.dataTransfer.types.length; i += 1) {
    if (e.dataTransfer.types[i].toLowerCase() === format.toLowerCase()) return true;
  }
  return false;
};

export { getDragValue, containsDragFormat };
